// extracted by mini-css-extract-plugin
export default {"CodeSettings-Label":"CodeSettings-Label3Ctn3JltHF-B"};